import { call, put, takeLatest } from "redux-saga/effects";
import request, { hashfameRequest } from "utils/request";
import { creatorsVerificationActions } from "./index";
import { showToast } from "components/ToastContainer/index";

function* fetchCreatorsVerificationList(action) {
  try {
    const response = yield call(request, `/api/instagram_platform_users`, {
      method: "POST",
      credentials: "include",
      body: JSON.stringify(action.payload),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      }
    });

    yield put(
      creatorsVerificationActions.fetchCreatorsInstagramSuccess(response)
    );
  } catch (error) {
    yield put(
      creatorsVerificationActions.fetchCreatorsInstagramFailure(error.message)
    );
  }
}

function* verifyCreatorSaga(action) {
  try {
    const queryString = Object.keys(action.payload)
      .map((key) => `${key}=${action.payload[key]}`)
      .join("&");
    const response = yield call(
      hashfameRequest,
      `/api/v1/update.instagram.for.creatorUser?${queryString}`,
      {
        method: "POST"
      }
    );
    yield put(creatorsVerificationActions.verifyCreatorSuccess(response));
    showToast(response.message, "success");
  } catch (error) {
    yield put(creatorsVerificationActions.verifyCreatorFailure(error.message));
    showToast(error.message, "danger");
    if (error) {
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }
  }
}

export function* creatorsVerificationSaga() {
  yield takeLatest(
    creatorsVerificationActions.fetchCreatorsInstagramRequest.type,
    fetchCreatorsVerificationList
  );
  yield takeLatest(
    creatorsVerificationActions.verifyCreatorRequest.type,
    verifyCreatorSaga
  );
}
